import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5247 15.8337C11.2726 15.8346 11.0336 15.7212 10.8747 15.5254L6.84973 10.5254C6.59697 10.2179 6.59697 9.77458 6.84973 9.46708L11.0164 4.46708C11.3109 4.1127 11.837 4.06419 12.1914 4.35874C12.5458 4.6533 12.5943 5.17936 12.2997 5.53375L8.57473 10.0004L12.1747 14.4671C12.3828 14.7168 12.4266 15.0648 12.287 15.3584C12.1474 15.652 11.8498 15.8375 11.5247 15.8337Z"
        fill="#919EAB"
        fillOpacity="0.8"
      />
    </svg>
  )
}

export default SvgComponent
